<template>
  <div>
    <CRow>
      <CCol sm="12">
        <PropertiesCatalogTable
          :items="properties"
          :pagination-data="pagination"
          hover
          striped
          small
          fixed
          caption="Inventario de Propiedades"
          @refreshItems="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import PropertiesCatalogTable from '../../components/assets/PropertiesCatalogTable.vue'
import ws from '../../services/properties'   // nuevo servicio para propiedades
import store from '../../store'

export default {
  name: 'PropertiesCatalog',
  components: { PropertiesCatalogTable },
  data () {
    return {
      properties: [],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        perPage: 30,
      },
      activeFilters: {}
    }
  },
  async mounted () {
    await this.getItems({ filters: {}, page: 1 })
  },
  methods: {
    async getItems (payload = {}) {
      this.loading()
      try {
        let filters = {}
        let page = 1
        let prioritizeNew = false
        let pinItem = null

        if (payload && payload.filters !== undefined) {
          filters = payload.filters || {}
          page = payload.page || 1
          prioritizeNew = !!payload.prioritizeNew
          pinItem = payload.pinItem || null
        } else {
          filters = payload || {}
        }

        this.activeFilters = filters

        const response = await ws.get({
          ...filters,
          page,
          per_page: this.pagination.perPage
        })
        if (response.type === 'success') {
          const data = response.data || {}
          let items = data.data || []

          if (prioritizeNew && pinItem && pinItem.id) {
            const pinId = Number(pinItem.id)
            items = [pinItem].concat(items.filter(item => Number(item.id) !== pinId))
            items = items.slice(0, this.pagination.perPage)
          }

          this.properties = items
          this.pagination = {
            ...this.pagination,
            currentPage: data.current_page || 1,
            totalPages: data.last_page || 1,
            totalItems: data.total || 0
          }
        }
      } finally {
        this.loaded()
      }
    },
    async refreshItems (payload) {
      await this.getItems(payload)
    },
    showToast (type, message) {
      store.commit('toast', { color: type, message: message })
    },
    loading () {
      store.commit('loading')
    },
    loaded () {
      store.commit('loaded')
    }
  }
}
</script>
